import type { NavSource } from "@/app/nav/types";

export type NavFlags = {
  /** Hard cut default: `api`. Set `legacy` only for emergency rollback. */
  source: NavSource;
  /** Hard cut default: false — Banner on API error. Soft-launch override: true. */
  fallback: boolean;
  /** Opt-in dual-run assert (staging). Default off after W5. */
  dualRun: boolean;
};

function envBool(raw: string | undefined, defaultValue: boolean): boolean {
  if (raw === undefined || raw === "") return defaultValue;
  const v = raw.trim().toLowerCase();
  if (v === "1" || v === "true" || v === "yes" || v === "on") return true;
  if (v === "0" || v === "false" || v === "no" || v === "off") return false;
  return defaultValue;
}

/** FRS-SYS-06 W5 hard-cut flags. */
export function getNavFlags(): NavFlags {
  const sourceRaw = import.meta.env.VITE_NAV_SOURCE?.trim().toLowerCase();
  const source: NavSource = sourceRaw === "legacy" ? "legacy" : "api";
  return {
    source,
    fallback: envBool(import.meta.env.VITE_NAV_FALLBACK, false),
    dualRun: envBool(import.meta.env.VITE_NAV_DUAL_RUN, false),
  };
}

let navFallbackTotal = 0;

/** Lightweight counter when emergency/legacy fallback path is used. */
export function recordNavFallback(reason: string): void {
  navFallbackTotal += 1;
  console.info("[nav_fallback_total]", { count: navFallbackTotal, reason });
}

export function getNavFallbackTotal(): number {
  return navFallbackTotal;
}
